import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import Spinner from '../../../../reusable/spinner/spinner.component';
import Client from '../../../../../tools/client';

import {
  FieldSection,
  FieldGroup,
  Label,
  Toggle,
  ButtonRow,
  Button,
  Input,
  Description
} from '../../configuration-sections.styles';

const client = new Client();

const MaintenanceConfigurationDisplay = () => {
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({
    maintenanceActive: false,
    maintenanceMessage: '',
    maintenanceReturnTimestamp: null
  });

  useEffect(() => {
    const fetchData = async () => {
      const configRes = await client.setup();
      const app = configRes.configuration?.app || {};

      const timestamp = app.maintenance?.returnTimestamp;
      setForm({
        maintenanceActive: app.maintenance?.active === 'true' || app.maintenance?.active === true,
        maintenanceMessage: app.maintenance?.message || '',
        maintenanceReturnTimestamp: timestamp ? new Date(Number(timestamp)) : null
      });

      setLoading(false);
    };

    fetchData();
  }, []);

  const handleToggle = (key) => {
    setForm({ ...form, [key]: !form[key] });
  };

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const handleSave = async () => {
    const updates = {
      'maintenance.active': String(form.maintenanceActive),
      'maintenance.message': form.maintenanceMessage || '',
      'maintenance.returnTimestamp': form.maintenanceReturnTimestamp
        ? String(form.maintenanceReturnTimestamp.getTime())
        : ''
    };

    for (const [key, value] of Object.entries(updates)) {
      await client.updateConfigurationByKey(`app.${key}`, { value });
    }

    setEditing(false);
  };

  if (loading) return <Spinner />;

  return (
    <FieldSection>
      <FieldGroup>
        <Label>Maintenance Mode Active</Label>
        <Description>
          When enabled, the site will be taken offline for visitors. Only the maintenance message will be shown.
        </Description>
        <Toggle>
          <input
            type="checkbox"
            checked={form.maintenanceActive}
            onChange={() => handleToggle('maintenanceActive')}
            disabled={!editing}
          />
          <span />
        </Toggle>
      </FieldGroup>

      <FieldGroup>
        <Label htmlFor="maintenanceMessage">Custom Maintenance Message</Label>
        <Description>
          This message will appear on the maintenance page to inform visitors about the downtime.
        </Description>
        <Input
          type="text"
          id="maintenanceMessage"
          value={form.maintenanceMessage}
          onChange={(e) => handleChange('maintenanceMessage', e.target.value)}
          disabled={!editing}
        />
      </FieldGroup>

      <FieldGroup>
        <Label>Return Time (Date + Time)</Label>
        <Description>
          Optional. Use this to indicate when the site is expected to return. This is for display purposes only.
        </Description>
        <DatePicker
          selected={form.maintenanceReturnTimestamp}
          onChange={(date) => handleChange('maintenanceReturnTimestamp', date)}
          showTimeSelect
          timeFormat="HH:mm"
          timeIntervals={5}
          dateFormat="yyyy-MM-dd h:mm aa"
          placeholderText="Select return time"
          disabled={!editing}
        />
      </FieldGroup>

      <ButtonRow>
        {editing ? (
          <>
            <Button onClick={() => setEditing(false)}>Cancel</Button>
            <Button primary onClick={handleSave}>Save</Button>
          </>
        ) : (
          <Button primary onClick={() => setEditing(true)}>Edit</Button>
        )}
      </ButtonRow>
    </FieldSection>
  );
};

export default MaintenanceConfigurationDisplay;